/*
  Meindersma: houdt de keuzes van de swatch-app (Globo) geldig.
  Als na het wijzigen van kleur of maat de gekozen waarde van een latere optie
  (bijv. verpakkingseenheid) niet meer bestaat, wordt die automatisch aangepast:
  - is er nog maar één mogelijke waarde, dan wordt die gekozen;
  - zijn er meerdere, dan wordt de oude keuze gewist zodat de klant opnieuw kiest.
  Ook wordt een optie met maar één mogelijke waarde automatisch gekozen.
  De verpakkingseenheid blijft verborgen tot er een maat is gekozen.
*/
(() => {
  const ROOT_SELECTOR = '.globo-swatch-product-detail';
  const PACK_OPTION = 'Verpakkingseenheid';
  const SIZE_OPTION = 'Maat';
  const WAITING_CLASS = 'mt-option-waiting';
  let syncing = false;
  let timer;

  // Globo verbergt waarden met display: none op de li; een verborgen optiegroep telt niet mee.
  const isVisible = (element) => !!element && getComputedStyle(element).display !== 'none';

  const optionGroups = (root) =>
    [...root.querySelectorAll('.swatch--gl[data-option-index]')].sort(
      (a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)
    );

  const optionName = (group) => group.querySelector('legend.name-option')?.dataset.name;

  const hasChoice = (group) =>
    [...group.querySelectorAll('li input[type="radio"]')].some(
      (input) => input.checked && isVisible(input.closest('li'))
    );

  const clearLabel = (group) => {
    const nameVariant = group.querySelector('.name-variant');
    if (nameVariant) nameVariant.textContent = '';
  };

  const updatePackVisibility = (root) => {
    const groups = optionGroups(root);
    const packIndex = groups.findIndex((group) => optionName(group) === PACK_OPTION);
    if (packIndex < 0) return;

    const sizeGroup = groups.find((group) => optionName(group) === SIZE_OPTION);
    const gates = sizeGroup ? [sizeGroup] : groups.slice(0, packIndex);
    groups[packIndex].classList.toggle(WAITING_CLASS, !gates.every(hasChoice));
  };

  const sync = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root || syncing) return;

    const groups = optionGroups(root);
    let previousChosen = true;

    for (const group of groups) {
      const inputs = [...group.querySelectorAll('li input[type="radio"]')];
      const available = inputs.filter((input) => isVisible(input.closest('li')));
      const checked = inputs.find((input) => input.checked);

      if (checked && !isVisible(checked.closest('li'))) {
        if (available.length === 1) {
          syncing = true;
          (available[0].closest('li').querySelector('label') || available[0]).click();
          syncing = false;
          return schedule();
        }
        checked.checked = false;
        clearLabel(group);
        previousChosen = false;
        continue;
      }

      if (!checked && previousChosen && available.length === 1) {
        syncing = true;
        (available[0].closest('li').querySelector('label') || available[0]).click();
        syncing = false;
        return schedule();
      }

      previousChosen = previousChosen && !!(checked && isVisible(checked.closest('li')));
    }

    updatePackVisibility(root);
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  };

  document.addEventListener(
    'change',
    (event) => {
      const root = event.target.closest?.(ROOT_SELECTOR);
      if (!root) return;
      updatePackVisibility(root);
      schedule();
    },
    true
  );

  // Globo bouwt de keuzes pas na het laden op: wacht tot ze er zijn.
  const waitForRoot = (attempts = 0) => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (root && root.querySelector('.swatch--gl[data-option-index]')) return updatePackVisibility(root);
    if (attempts < 100) setTimeout(() => waitForRoot(attempts + 1), 100);
  };
  waitForRoot();
})();
